module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1"
  }, [_c('span', [_vm._v("The Bad Boy Next Door")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text_2"
  }, [_c('span', [_vm._v("Dangerous Desire, Book 1")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text_3"
  }, [_c('span', [_vm._v("Lexxie Couper")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Published 2016 by Book Boutiques.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("ISBN: 978-1-944003-28-9")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Copyright © 2016, Lexxie Couper.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, recording, or otherwise, without the prior written permission of Book Boutiques.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("This book is a work of fiction. Any similarity to actual persons, living or dead, locales, or events is wholly coincidental. The names, characters, dialogue, and events in this book are from the author’s imagination and should not to be construed as real.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Manufactured in the USA.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Email support@bookboutiques.com with questions, or inquiries about Book Boutiques.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 63
// module chunks = 0